'use client';

import React, { useState } from 'react';

export default function RumbaEmailSubscribe() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error' | 'duplicate'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('loading');
    setErrorMsg('');

    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      if (res.status === 409) {
        setStatus('duplicate');
        return;
      }

      if (!res.ok) {
        const data = await res.json();
        setErrorMsg(data?.error || 'Error al suscribirse.');
        setStatus('error');
        return;
      }

      setStatus('success');
      setEmail('');
    } catch (err: any) {
      setErrorMsg(err?.message || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  return (
    <div
      className="w-full max-w-md mx-auto"
    >
      <p className="text-xs font-bold uppercase tracking-widest mb-2 text-center" style={{ color: '#fb923c' }}>
        Mantente Informado
      </p>
      <h3 className="text-base font-black text-foreground text-center mb-1" style={{ letterSpacing: '-0.01em' }}>
        Suscríbete a RUMBAEXPLOSIONS
      </h3>
      <p className="text-xs text-muted-foreground text-center mb-4">
        Recibe actualizaciones, anuncios de shows y novedades directamente en tu correo.
      </p>

      {status === 'success' ? (
        <div
          className="flex items-center gap-2 justify-center px-4 py-3 rounded-xl"
          style={{ background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.25)' }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          <span className="text-sm font-semibold" style={{ color: '#22c55e' }}>
            ¡Suscripción exitosa! Gracias por unirte.
          </span>
        </div>
      ) : status === 'duplicate' ? (
        <div
          className="flex items-center gap-2 justify-center px-4 py-3 rounded-xl"
          style={{ background: 'rgba(251,146,60,0.1)', border: '1px solid rgba(251,146,60,0.25)' }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fb923c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span className="text-sm font-semibold" style={{ color: '#fb923c' }}>
            Este correo ya está suscrito.
          </span>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@correo.com"
            required
            disabled={status === 'loading'}
            className="flex-1 text-sm px-4 py-2.5 rounded-xl outline-none transition-all duration-150"
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(239,68,68,0.2)',
              color: 'var(--foreground)',
            }}
            onFocus={(e) => { e.currentTarget.style.borderColor = 'rgba(239,68,68,0.5)'; }}
            onBlur={(e) => { e.currentTarget.style.borderColor = 'rgba(239,68,68,0.2)'; }}
          />
          <button
            type="submit"
            disabled={status === 'loading' || !email.trim()}
            className="text-sm font-bold px-5 py-2.5 rounded-xl transition-all duration-150 flex items-center gap-2 justify-center flex-shrink-0"
            style={{
              background: status === 'loading' ? 'rgba(239,68,68,0.4)' : 'linear-gradient(135deg, #ef4444, #fb923c)',
              color: 'white',
              opacity: status === 'loading' || !email.trim() ? 0.7 : 1,
              cursor: status === 'loading' || !email.trim() ? 'not-allowed' : 'pointer',
            }}
          >
            {status === 'loading' ? (
              <>
                <svg className="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                Enviando…
              </>
            ) : (
              'Suscribirme'
            )}
          </button>
        </form>
      )}

      {status === 'error' && (
        <p className="text-xs mt-2 text-center" style={{ color: '#f87171' }}>
          {errorMsg || 'Error al suscribirse. Intenta de nuevo.'}
        </p>
      )}
    </div>
  );
}
